export type ChipSurface = 'white' | 'beige' | 'muted' | 'fraim'

type ChipProps = {
  label: string
  /**
   * チップ自身の面色。白いチップは生成りの面（bg-surface-subtle）の上に、
   * ベージュのチップは白い面（bg-surface）の上に置く。
   * muted は終了・無効を示す灰地（例: セミナーの「受付終了」）。
   * fraim はニュースの「FRAIM」ラベル。旧サイトのバッジと同じ純黒の地に白の太字。
   */
  surface?: ChipSurface
  /** 選択中。地を黒に反転する */
  selected?: boolean
  /** 渡すと button として描画し、hover で押せることを示す黒になる */
  onClick?: () => void
  className?: string
}

const baseClasses =
  'inline-flex h-8 items-center justify-center rounded-sm border px-2 py-1 text-sm leading-compact'

const surfaceClasses: Record<ChipSurface, string> = {
  white: 'bg-surface border-line-subtle text-ink',
  beige: 'bg-surface-subtle border-line-subtle text-ink',
  muted: 'bg-surface-disabled border-surface-disabled text-ink-inverse',
  fraim: 'bg-badge-fraim border-badge-fraim font-bold text-ink-inverse'
}

const selectedClasses =
  'bg-surface-inverse border-line-inverse text-ink-inverse font-bold'

export function Chip({
  label,
  surface = 'white',
  selected = false,
  onClick,
  className = ''
}: ChipProps) {
  const classes = [
    baseClasses,
    selected ? selectedClasses : surfaceClasses[surface],
    onClick && !selected
      ? 'transition-colors duration-120 hover:bg-surface-inverse hover:border-line-inverse hover:text-ink-inverse'
      : '',
    onClick ? 'cursor-pointer' : '',
    className
  ]
    .filter(Boolean)
    .join(' ')

  if (!onClick) {
    return <span className={classes}>{label}</span>
  }

  return (
    <button
      type="button"
      className={classes}
      aria-pressed={selected}
      onClick={onClick}
    >
      {label}
    </button>
  )
}
